import {PriceModel} from './Price.model';
import {AdditionalFeeFragment} from '../../../gql/graphql';
import {ModelContext} from '../../../types/checkoutApp.types';
import {mapNullToUndefined} from '../../utils/mapperHelper.utils';
import {SPECS} from '../../../common/constants';

export class AdditionalFeeModel {
  public code: string;
  public name: string;
  public priceBeforeTax: PriceModel;

  constructor(additionalFee: AdditionalFeeFragment, modelContext: ModelContext) {
    this.code = additionalFee.code!;
    this.name = modelContext.flowAPI.experiments.enabled(SPECS.UseAdditionalFeeTranslatedNameCheckout)
      ? mapNullToUndefined(additionalFee.translatedName) ?? additionalFee.name!
      : additionalFee.name!;
    this.priceBeforeTax = new PriceModel(additionalFee.priceBeforeTax, modelContext);
  }
}
